import { useLanguage } from "../../../../../stores/LanguageStore";
import {
  ActionIcon,
  Button,
  Group,
  Modal,
  Radio,
  RadioGroup,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useState } from "react";
import {
  deleteStatusCustom,
  updateProspectsStatus,
} from "../../../../../api/PRMAPI";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../../components/View/BackButton";
import PRMStatusSelector from "../../../../../components/Selectors/PRMStatusSelector";
import { useProfileStore } from "../../../../../stores/UserStore";
import { useParams } from "react-router-dom";
import { useLeadsContainerStore } from "../../../../../stores/LeadsStore";

const DeleteStatus = ({ id, statusName, handleRefresh, disabled, number }) => {
  const lang = useLanguage((s) => s.language);
  const { userId } = useParams();
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState("redo");

  const [status, setStatus] = useState("opener");

  const handleDelete = async () => {
    function main() {
      deleteStatusCustom({ id })
        .then((response) => {
          handleRefresh("delete", id);
          setOpened(false);
          notifications.show({
            message: lang.prm.status.deleted,
            color: "tertiary.8",
          });
        })
        .then((r) => {
          if (state === "move") {
            let containers = useLeadsContainerStore.getState().containers;
            let setContainers = useLeadsContainerStore.getState().setContainers;
            let newContainers = [
              ...containers.map((x) => {
                if (x.id?.toString() === status) {
                  return { ...x, loading: true };
                }
                return x;
              }),
            ];

            return setContainers(newContainers);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
    setLoading(true);
    if (state === "move") {
      setLoading(true);
      await updateProspectsStatus({
        user_id: parseInt(userId) || useProfileStore.getState().profile?.id,
        contacts_selection: {
          filter: {
            mode: "and",
            values: [
              {
                field_name: "custom_status",
                type: "equals",
                value: id.toString(),
              },
            ],
          },
          contact_ids: [],
          excluded_contact_ids: [],
        },
        custom_status: parseInt(status) || null,
        status: parseInt(status) ? null : status,
      })
        .then((r) => main())
        .catch(() => setLoading(false));
    } else {
      main();
    }
  };

  return (
    <>
      <Tooltip label={lang.prm.status.delete}>
        <ActionIcon
          size={"sm"}
          variant="light"
          disabled={disabled}
          color="red"
          onClick={() => setOpened(true)}
        >
          <IconTrash size={16} />
        </ActionIcon>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={lang.prm.status.deletion_title}
        centered
      >
        <Text>
          {lang.prm.status.delete_text} <b>{statusName}</b>{" "}
          {lang.prm.status.with}{" "}
          <b>
            {number > -1 ? number : " - "} {lang.prm.status.prospect}
          </b>{" "}
          ?
        </Text>

        <RadioGroup value={state} onChange={setState} mt={8}>
          <Radio
            label={lang.prm.status.delete_redo}
            color="red"
            value={"redo"}
            size="md"
          />

          <Radio
            label={lang.prm.status.move_prospects_text}
            value={"move"}
            size="md"
            mt={"lg"}
            mb={8}
          />
          <PRMStatusSelector
            value={status}
            onChange={setStatus}
            w={"100%"}
            required
            withinPortal={true}
            disabled={state !== "move"}
            noLabel
            disabledOption={id}
            size={"md"}
          />
        </RadioGroup>

        <Group mt={"lg"} justify="end">
          <BackButton onClick={() => setOpened(false)} size="md" />

          <Button
            color="red"
            onClick={handleDelete}
            loading={loading}
            size="md"
          >
            {lang.prm.status.delete}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default DeleteStatus;
